import { cx } from "class-variance-authority";
import { ReactNode } from "react";
type Props = {
  className?: string;
  children?: ReactNode;
};
export function H1({
  className,
  children
}: Props) {
  return <h2 className={cx("scroll-m-20 pb-2 text-5xl font-semibold tracking-tight first:mt-0", className)} data-sentry-component="H1" data-sentry-source-file="typography.tsx">
      {children}
    </h2>;
}
export function H2({
  className,
  children
}: Props) {
  return <h2 className={cx("scroll-m-20 pb-2 text-3xl font-semibold tracking-tight first:mt-0", className)} data-sentry-component="H2" data-sentry-source-file="typography.tsx">
      {children}
    </h2>;
}
export function H3({
  className,
  children
}: Props) {
  return <h3 className={cx("scroll-m-20 text-2xl font-medium tracking-tight text-gray-10", className)} data-sentry-component="H3" data-sentry-source-file="typography.tsx">
      {children}
    </h3>;
}
export function H4({
  className,
  children
}: Props) {
  return <h4 className={cx("scroll-m-20 text-xl font-medium tracking-tight text-gray-10", className)} data-sentry-component="H4" data-sentry-source-file="typography.tsx">
      {children}
    </h4>;
}
export function H5({
  className,
  children
}: Props) {
  return <h5 className={cx("scroll-m-20 font-medium tracking-tight text-gray-10", className)} data-sentry-component="H5" data-sentry-source-file="typography.tsx">
      {children}
    </h5>;
}
export function Label({
  className,
  children
}: Props) {
  return <span className={cx("text-xs font-normal text-gray-6 sm:text-sm", className)} data-sentry-component="Label" data-sentry-source-file="typography.tsx">
      {children}
    </span>;
}